<template>
  <div>
    <!-- 脚步按钮组 -->
    <div class="footer df-item-center">
      <div
        class="fun_grid df-center df-column fun_grid1"
        @click="openPhone"
      >
        <img src="../../assets/images/serviceList/i-phone.png" alt="" />
        <span>电话咨询</span>
      </div>
      <div class="fun_grid df-center df-column" @click="openWx">
        <img src="../../assets/images/serviceList/i-wx.png" alt="" />
        <span>微信咨询</span>
      </div>
      <div class="down_app_btn df-center" @click="goDownAppPath">下载APP</div>
    </div>
    <!-- 打电话 -->
    <van-action-sheet
      v-model="phoneShow"
      :actions="phoneActions"
      @select="phoneSelect"
      cancel-text="取消"
      close-on-click-action
    />
    <!-- 微信联系 -->
    <van-action-sheet
      v-model="wxShow"
      cancel-text="取消"
      close-on-click-action
      title="体验/购买  请识别图中二维码添加微信"
      :closeable="false"
      class="wxAcSheet"
    >
      <div class="content df-center qr_code_box">
        <img src="../../assets/images/i-wx-code.jpg" alt="" />
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
export default {
  data() {
    return {
      // 电话弹框显示
      phoneShow: false,
      // 电话弹框显示列表
      phoneActions: [{ name: "呼叫 400-969-7756" }],
      // 添加微信弹框
      wxShow: false,
      imgUrl: ''
    };
  },
   mounted() {
      // this.$nextTick(() => {
      //   this.initImg()
      // })
      this.$nextTick(() => {
        setTimeout(() => {
          // this.initImg()
        }, 200)
      })
    },
  methods: {
    openWx() {
       this.cnzzStat('服务清单及报价', '服务清单及报价页面点击微信咨询按钮','微信咨询(SE_Key_Wechat_Consulting)');
      this.wxShow = true
    },
    openPhone() {
      this.cnzzStat('服务清单及报价', '服务清单及报价页面点击电话咨询按钮','电话咨询(SE_Key_Phone_Consulting)');
      this.phoneShow = true
    },
    // 选择了电话
    phoneSelect(e) {
      this.callPhone(e.name);
      console.log(e);
    },
    // 下载APP
    goDownAppPath() {
      this.cnzzStat('服务清单及报价', '服务清单及报价页面点击下载APP按钮','下载APP(SE_Key_Downloading)');
      this.$router.push("/download/downloadApp");
    },
    initImg() {
      // 背景图需要设置给将要截取图片的子级subjectsuccess-body，不然截取的图片背景图显示不出
      new html2canvas(document.querySelector(".qr_code_box"), {
        useCORS: true,
      }).then((canvas) => {
        this.imgUrl = canvas.toDataURL();
        console.log(this.imgUrl, "图片路径....");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  box-sizing: border-box;
  padding: 0 12px 0 22px;
  z-index: 999;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  opacity: 1;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(81, 116, 143, 0.16);
  .fun_grid {
    img {
      width: 22px;
      height: 22px;
      margin-bottom: 2px;
    }
    span {
      text-align: center;
      color: #333333;
    }
  }
  .fun_grid1 {
    margin-right: 44px;
  }
  // .fun_grid:last-child {
  //     margin-left: 44px;
  // }
  .down_app_btn {
    margin-left: auto;
    width: 136px;
    height: 40px;
    opacity: 1;
    background: #1c91ff;
    border-radius: 5px;
    font-size: 18px;
    color: #ffffff;
  }
}
/deep/ .van-action-sheet__item {
  color: rgb(58, 169, 253);
}
.wxAcSheet {
  .content {
    img {
      width: 250px;
      height: 250px;
      margin-bottom: 20px;
    }
  }
}
</style>